export const data = {
  profile: {
    id: 1,
    name: "Bhavani Singh",
    image:
      "https://us.123rf.com/450wm/yellowcrest/yellowcrest0911/yellowcrest091100073/5891555-a-portrait-of-an-indian-boy-against-a-black-background.jpg?ver=6",
    contacts: [
      {
        id: 2,
        name: "Vishal",
        image:
          "https://images.pexels.com/photos/1042140/pexels-photo-1042140.jpeg?cs=srgb&dl=pexels-rahul-shah-1042140.jpg&fm=jpg",
        chatlog: [
          {
            text: "Hi Bro,How are you!",
            timestamp: "10:01 AM",
            sender: "user",
            message_id: 1,
          },
          {
            text: "I am fine vishal. How are you!",
            timestamp: "10:02 AM",
            sender: "me",
            message_id: 2,
          },
          {
            text: "I am great, Bhavani.",
            timestamp: "10:03 AM",
            sender: "user",
            message_id: 3,
          },
          {
            text: "Or maybe not, let me check something and call you. Give me sometime",
            timestamp: "10:04 AM",
            sender: "user",
            message_id: 4,
          },
          {
            text: "Oky Bro !",
            timestamp: "10:05 AM",
            sender: "me",
            message_id: 5,
          },
        ],
      },
      {
        id: 3,
        name: "Sourabh Srivastav",
        image:
          "https://media.istockphoto.com/photos/portrait-of-a-confident-young-man-picture-id1141737652?b=1&k=20&m=1141737652&s=170667a&w=0&h=1Ni7irJ6VB9BXN7LbJIdNHP0h5EMoyJcRyvXl5_nzDs=",
        chatlog: [
          {
            text: "Hi Dear,How are you!",
            timestamp: "10:01 AM",
            sender: "user",
            message_id: 1,
          },
          {
            text: "I am fine Santosh. How are you!",
            timestamp: "10:02 AM",
            sender: "me",
            message_id: 2,
          },
          {
            text: "I am great,Dear.",
            timestamp: "10:03 AM",
            sender: "user",
            message_id: 3,
          },
          {
            text: "Or maybe not, let me check something and call you. Give me sometime",
            timestamp: "10:04 AM",
            sender: "user",
            message_id: 4,
          },
          {
            text: " Do you know, who is Arnab?",
            timestamp: "10:05 AM",
            sender: "me",
            message_id: 5,
          },
        ],
      },
      {
        id: 4,
        name: "Arnab",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGuly7YOKkWmN5QIMM3Gs6xXcYVoYvTSs6OA&usqp=CAU",
        chatlog: [
          {
            text: "Hi Bhavani,How are you!",
            timestamp: "10:01 AM",
            sender: "user",
            message_id: 1,
          },
          {
            text: "I am fine Arnab. How are you!",
            timestamp: "10:02 AM",
            sender: "me",
            message_id: 2,
          },
          {
            text: "I am great ,  Bhavani.",
            timestamp: "10:03 AM",
            sender: "user",
            message_id: 3,
          },
          {
            text: "Or maybe not, let me check something and call you. Give me sometime",
            timestamp: "10:04 AM",
            sender: "user",
            message_id: 4,
          },
          {
            text: "Okay No issue !",
            timestamp: "10:05 AM",
            sender: "me",
            message_id: 5,
          },
        ],
      },
      {
        id: 5,
        name: "Shubham Jha",
        image:
          "https://static8.depositphotos.com/1008939/800/i/600/depositphotos_8003753-stock-photo-indian-man.jpg",
        chatlog: [],
      },
      {
        id: 6,
        name: "Manish Singh",
        image:
          "https://www.thehandbook.com/cdn-cgi/image/width=300,height=300,fit=cover,q=85/https://files.thehandbook.com/uploads/2020/11/119045631-2755046064740370-3627763337265706601-n.jpg",
        chatlog: [
          {
            text: "Hey Bhavani, where is Aman?",
            timestamp: "10:01 AM",
            sender: "user",
            message_id: 1,
          },
          {
            text: "I don't know anything about, Aman",
            timestamp: "10:02 AM",
            sender: "me",
            message_id: 2,
          },
          {
            text: "Are you sure,  Bhavani.",
            timestamp: "10:03 AM",
            sender: "user",
            message_id: 3,
          },
          {
            text: "Yes, I am sure",
            timestamp: "10:05 AM",
            sender: "me",
            message_id: 4,
          },
        ],
      },
      {
        id: 7,
        name: "Aman Kumar",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Jensen_Ackles_by_Gage_Skidmore_2.jpg/750px-Jensen_Ackles_by_Gage_Skidmore_2.jpg",
        chatlog: [
          {
            text: "Hey Aman, Arnab is asking about you.",
            timestamp: "10:06 AM",
            sender: "me",
            message_id: 1,
          },
          {
            text: "Did you tell him anything, Bhavani.",
            timestamp: "10:06 AM",
            sender: "user",
            message_id: 2,
          },
          {
            text: "No Aman, I haven't told him anything yet!!!.",
            timestamp: "10:07 AM",
            sender: "me",
            message_id: 3,
          },
          {
            text: "What do you mean yet!!!.",
            timestamp: "10:08 AM",
            sender: "user",
            message_id: 4,
          },
          {
            text: "Nothing Aman, You take care now and if you need anything tell me",
            timestamp: "10:09 AM",
            sender: "me",
            message_id: 5,
          },
          {
            text: "Sure Bhavani, Take care !",
            timestamp: "10:09 AM",
            sender: "user",
            message_id: 6,
          },
        ],
      },
      {
        id: 8,
        name: "Jason Roy",
        image:
          "https://global-uploads.webflow.com/5d121ce15cf154f8f7d91740/5fb7e016798aa0ccca2ca0ba_Abhishek%20Dwivedi.jpg",
        chatlog: [],
      },
      {
        id: 9,
        name: "Nikhil Tiwari",
        image:
          "https://st4.depositphotos.com/13187390/i/600/depositphotos_272629826-stock-photo-handsome-young-indian-man-showing.jpg",
        chatlog: [],
      },
    ],
  },
};
